export interface DischargeTime {
  dischargeTimeId: number;
  dischargeTimeCode: string;
  dischargeTimeDesc: string;
}
